import { Pagination, TableCell, TableRow, useTheme } from "@mui/material";
import { scheduleVariables } from "../../../../variables";

interface ScheduleMeetingsPaginationProps {
    itemCount: number;
    page: number;
    onPageChange: (newPage: number) => void;
}

export const ScheduleMeetingsPagination = ({
    itemCount, page, onPageChange
}: ScheduleMeetingsPaginationProps) => {

    const theme = useTheme();
    const count = Math.ceil(itemCount / scheduleVariables.meetingPageSize);

    return (
        <>
            {itemCount > scheduleVariables.meetingPageSize &&
                <TableRow>
                    <TableCell colSpan={6} sx={{ backgroundColor: theme.palette.grey[200] }}>
                        <Pagination
                            id='schedule-meetings-pagination'
                            count={count}
                            size='small'
                            page={page}
                            sx={{ "& > .MuiPagination-ul": { justifyContent: "center" } }}
                            onChange={(_, value) => onPageChange(value)}
                        />
                    </TableCell>
                </TableRow>
            }
        </>
    )
}
